import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'shalala';
import Validator from 'validatorjs';
import { Button, Row, Col, Form } from 'react-bootstrap';

import { useStore } from '../../../store';
import { Guardian } from '@xaamin/guardian';
import { FormControl } from '../../../facturotopia';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';
import ReceptorFiscalInfoForm from './components/ReceptorFiscalInfoForm';
import ReceptorNominaInfoForm from './components/ReceptorNominaInfoForm';
import ReceptorFiscalAddressForm from './components/ReceptorFiscalAddressForm';

const steps = [
  {
    number: 1,
    key: 'fiscal-info',
    done: false,
  },
  {
    number: 2,
    key: 'fiscal-address',
    done: false,
  },
  {
    number: 3,
    key: 'nomina-info',
    done: true,
  },
  {
    number: 4,
    key: 'password',
    done: true,
  },
];

class ReceptorUpsert extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;

    this.state = {
      datos_nomina: !!data.nomina,
      data: { ...data },
      steps: [...steps],
      isTouchedPassword: false,
      validator: new Validator({}, this.rules),
    };

    props.upsertActions.setPartialState(this.state);
  }

  componentWillUnmount() {
    this.props.upsertActions.reset();
  }

  get rules() {
    const { isTouchedPassword } = this.state;

    const PasswordRules = ['confirmed', 'min:8', 'password'];
    const PasswordConfirmationRules = ['min:8', 'password'];

    return {
      password: !!isTouchedPassword ? ['required'].concat(PasswordRules) : PasswordRules,
      password_confirmation: !!isTouchedPassword
        ? ['required'].concat(PasswordConfirmationRules)
        : PasswordConfirmationRules,
    };
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertActions.setPartialState({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    if (!!this.props.onComplete) {
      this.props.onComplete();
    }
  };

  handleOnConfirm = async () => {
    const { id } = this.props;

    const {
      data,
      data: { direccion = {} },
    } = this.props.upsert;
    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    const body = {
      ...info,
      id: id ? undefined : data.id,
      status: undefined,
      direccion: direccion,
    };

    await this.props.upsertActions.upsert(body, id);

    const { result } = this.props.upsert;

    if (!!result && this.props.onComplete) {
      this.props.onComplete(result);
    }
  };

  handleOnDataChange = (event) => {
    this.props.upsertActions.setStepDataChange({
      ...event,
    });
  };

  handleOnFiscalAddressDataChange = (event) => {
    let data = {
      ...this.props.upsert.data,
      direccion: event.data,
    };

    this.handleOnDataChange({
      ...event,
      data,
    });
  };

  handleOnNominaDataChange = (event) => {
    const data = {
      ...this.props.upsert.data,
      nomina: event.data,
    };

    this.handleOnDataChange({
      ...event,
      data,
    });
  };

  handleNominaCheckboxOnChange = (event) => {
    const { name, checked } = event.target;

    const data = {
      ...this.props.upsert.data,
      nomina: undefined,
    };

    this.setState({
      [name]: checked,
    });

    this.handleOnDataChange({
      step: { ...steps[2] },
      data,
      isValid: !checked,
    });
  };

  handleOnPasswordDataChange = (value) => {
    const data = {
      ...this.props.upsert.data,
      ...value,
    };

    const validator = this.validate(data);

    this.handleOnDataChange({
      step: { ...steps[3] },
      data,
      isValid: validator.passes(),
    });

    const isTouched = !_.isEmpty(data.password) && !_.isEmpty(data.password_confirmation);

    this.setState({
      isTouchedPassword: isTouched,
    });
  };

  handleOnChangeCustom = (value) => {
    this.props.upsertActions.setStepDataChange({
      step: {},
      data: {
        ...this.props.upsert.data,
        ...value,
      },
    });
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result, data } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title={data.id ? 'Información actualizada' : 'Registro completado'}
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { id, info, upsert } = this.props;
    const { datos_nomina, validator } = this.state;
    const { data = {}, steps = [], error, result, isValid, busy, onComplete } = upsert;

    if (info.busy || steps.length === 0) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        {!!result && !!onComplete && this.renderResult()}

        {!id && (
          <>
            <Row>
              <Col xs="12">
                <div className="py-3">
                  <strong className="text-info">PERSONALIZAR RECEPTOR</strong>
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={10}
              >
                <FormControl
                  type="text"
                  label="Id del receptor"
                  name="id"
                  placeholder="xxxxxxxx-xxxx-zxxx-yxxx-xxxxxxxxxxxx"
                  help="UUID del receptor en el sistema"
                  value={data.id}
                  rules={['string', 'min:36']}
                  onChange={this.handleOnChangeCustom}
                />
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">INFORMACIÓN FISCAL</strong>
            </div>

            <ReceptorFiscalInfoForm
              data={data}
              step={steps[0]}
              autoFocus={true}
              history={this.props.history}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">DOMICILIO FISCAL</strong>
            </div>

            <ReceptorFiscalAddressForm
              data={data.direccion || {}}
              step={steps[1]}
              onFormDataChange={this.handleOnFiscalAddressDataChange}
            />
          </Col>
        </Row>

        <Form.Group
          controlId="datos_nomina"
          className="mb-4"
        >
          <Form.Check
            type="checkbox"
            name="datos_nomina"
            label="Dar de alta como empleado (Nómina)"
            checked={datos_nomina || false}
            onChange={this.handleNominaCheckboxOnChange}
          />
        </Form.Group>

        {!!datos_nomina && (
          <ReceptorNominaInfoForm
            data={data.nomina}
            step={steps[2]}
            autoFocus={true}
            history={this.props.history}
            onFormDataChange={this.handleOnNominaDataChange}
          />
        )}

        {Guardian.allows('portal_receptores.access') && (
          <>
            <div className="d-block mt-3 mb-2">
              <strong>Portal de receptores</strong>
            </div>

            <Row>
              <Col>
                <p className="text-muted">
                  El receptor podrá iniciar sesión al portal usando su Email o RFC más la Contraseña. Te recomendamos
                  ingresar una contraseña segura para después proporcionarla al receptor por el medio que desees.
                </p>
                <ul>
                  <li>Sea de al menos 8 caracteres</li>
                  <li>No contenga el RFC o nombre (No usar TURFC123)</li>
                  <li>Contenga al menos una mayúscula, un número y un caracter especial ($%&#.?¡@/)</li>
                </ul>
              </Col>
            </Row>

            <Row>
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={5}
              >
                <FormControl
                  type="password"
                  label="Contraseña"
                  name="password"
                  validator={validator}
                  value={data.password}
                  onChange={this.handleOnPasswordDataChange}
                />
              </Col>

              <Col
                xs={12}
                sm={12}
                md={6}
                lg={5}
              >
                <FormControl
                  type="password"
                  label="Confirmar Contraseña"
                  name="password_confirmation"
                  validator={validator}
                  value={data.password_confirmation}
                  onChange={this.handleOnPasswordDataChange}
                />
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-2"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnConfirm}
            >
              {!!id ? (busy ? 'Actualizando...' : 'Guardar') : ''}
              {!id ? (busy ? 'Registrando...' : 'Registrar') : ''}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    info: store.app.receptores.info,
    upsert: store.app.receptores.upsert,
  };
};

const mapActions = (actions) => {
  return {
    infoActions: actions.app.receptores.info,
    upsertActions: actions.app.receptores.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(ReceptorUpsert);
